import { createSelector } from 'reselect';
import formatName from 'I18n/utils/formatName';
import { getFirstName } from './getFirstName';
import { getLastName } from './getLastName';
export const getFullName = createSelector([getFirstName, getLastName], (firstName, lastName) => formatName({
  firstName,
  lastName
}));